import { HelpTagDefinition } from "./interfaces";

//
// all the tags should follow the tree-like structure
// tags for the page general manual should end with ".$"
// there should be no tags without a dot in it
//
export const BASE_TAGS = [
    // ---
    // layout
    // header
    {
        tag: "header.tracker",
        name: "Tracker component in the header",
    },
    // ---
    // dashboard
    {
        tag: "dashboard.$",
        name: "General manual for dashboard",
    },
    {
        tag: "dashboard.month-overview.general",
        name: "Month overview",
    },
    {
        tag: "dashboard.hours-distribution.general",
        name: "Hours distribution",
    },
    {
        tag: "dashboard.reported-contracted.general",
        name: "Hours distribution",
    },
    {
        tag: "dashboard.calendar-schedule.general",
        name: "Calendar schedule",
    },
    // ---
    // admin/time page
    {
        tag: "admin-time.$",
        name: "General manual for time reporting",
    },
    // shared
    {
        tag: "admin-time.shared.calendar-track",
        name: "Start a track button for calendar events",
    },
    {
        tag: "admin-time.shared.report-all",
        name: "Report all button in the time reporting",
    },
    {
        tag: "admin-time.shared.fill-out",
        name: "Fill-out button in the time reporting",
    },
    {
        tag: "admin-time.shared.templates",
        name: "Templates in the time reporting",
    },
    {
        tag: "admin-time.shared.project-field",
        name: "Project field for an activity",
    },
    {
        tag: "admin-time.shared.fee-category-field",
        name: "Fee category (LoB) field for an activity",
    },
    {
        tag: "admin-time.shared.fee-code-field",
        name: "Fee code field for an activity",
    },
    {
        tag: "admin-time.shared.duration-field",
        name: "Duration field for an activity",
    },
    {
        tag: "admin-time.shared.reverse-button",
        name: "Reverse button for an activity",
    },
    {
        tag: "admin-time.shared.unreport-button",
        name: "Unreport button for an activity",
    },
    // month
    {
        tag: "admin-time.month.general",
        name: "Calendar month view",
    },
    {
        tag: "admin-time.month.cell",
        name: "Cell in the month view in time reporting",
        selectors: [
            { selector: "gray", name: "If cell has gray color" },
            { selector: "red", name: "If cell has red color" },
            { selector: "green", name: "If cell has green color" },
            { selector: "yellow", name: "If cell has yellow color" },
            {
                selector: "striped",
                name: "If cell striped (green color with dot)",
            },
        ],
    },
    {
        tag: "admin-time.month.contracts",
        name: "Contracted, tracked and reported hours in the month view in time reporting",
    },
    {
        tag: "admin-time.month.day-status-selector",
        name: "Day status selector in the month view in time reporting",
    },
    {
        tag: "admin-time.month.add-activity",
        name: "Add activity in the month view in time reporting",
    },
    // week
    {
        tag: "admin-time.week.general",
        name: "Calendar week view",
    },
    {
        tag: "admin-time.week.slot",
        name: "Slot functions in the timeline",
    },
    // week-day
    {
        tag: "admin-time.week-day.scale-range",
        name: "Scale range for week and day view in time reporting",
    },
    {
        tag: "admin-time.week-day.add-activity",
        name: "Add activity for week and day view in time reporting",
    },
    // day
    {
        tag: "admin-time.day.general",
        name: "Calendar day view",
    },
    {
        tag: "admin-time.day.column-all",
        name: "Column 'All' in the day view in time reporting",
    },
    {
        tag: "admin-time.day.column-task",
        name: "Column 'Task' in the day view in time reporting",
    },
    {
        tag: "admin-time.day.column-timer",
        name: "Column 'Timer' in the day view in time reporting",
    },
    {
        tag: "admin-time.day.column-calendar",
        name: "Column 'Calendar' in the day view in time reporting",
    },
    {
        tag: "admin-time.day.column-custom",
        name: "Column 'Custom' in the day view in time reporting",
    },
    {
        tag: "admin-time.day.reported-contracted",
        name: "Reported/Contracted in the day view in time reporting",
    },
    // panel
    {
        tag: "admin-time.panel.connect-outlook",
        name: "Connect Outlook button in the time reporting panel",
    },
    {
        tag: "admin-time.panel.filter-calendars",
        name: "Select which calendars to show when multiple calendars are chosen in the profile",
    },
    {
        tag: "admin-time.panel.types",
        name: "Types filter in the time reporting panel",
    },
    {
        tag: "admin-time.panel.statuses",
        name: "Statuses filter in the time reporting panel",
    },
    {
        tag: "admin-time.panel.mode-month",
        name: "Month mode in the time reporting panel",
    },
    {
        tag: "admin-time.panel.mode-week",
        name: "Week mode in the time reporting panel",
    },
    {
        tag: "admin-time.panel.mode-day",
        name: "Day mode in the time reporting panel",
    },
    // ---
    // admin/expenses page
    {
        tag: "admin-expenses.$",
        name: "General manual for expenses",
    },
    {
        tag: "admin-expenses.expense.actions",
        name: "Actions for an expense in the expenses",
    },
    {
        tag: "admin-expenses.expense.submit",
        name: "Submit button for an expense in the expenses",
    },
    {
        tag: "admin-expenses.expense.status",
        name: "Status for an expense in the expenses",
        selectors: [
            { selector: "submitted", name: "Submitted" },
            { selector: "not_submitted", name: "Not Submitted" },
            { selector: "not_submitted_ready", name: "Not Submitted Ready" },
            { selector: "approved", name: "Approved" },
            { selector: "booked_unpaid", name: "Booked Not Paid" },
            { selector: "booked_paid", name: "Booked Paid" },
            { selector: "deleted", name: "Deleted" },
        ],
    },
    {
        tag: "admin-expenses.receipt.status",
        name: "Status for a receipt in the expenses",
        selectors: [
            { selector: "incomplete", name: "Incomplete" },
            { selector: "needs_review", name: "Needs Review" },
            { selector: "ready", name: "Ready" },
        ],
    },
    {
        tag: "admin-expenses.expense.add",
        name: "Add expense form in the expenses",
    },
    {
        tag: "admin-expenses.expense.remove",
        name: "Remove expenses button in the expenses",
    },
    {
        tag: "admin-expenses.panel.statuses",
        name: "Statuses filter in the expenses panel",
    },
    {
        tag: "admin-expenses.receipt.date",
        name: "Date field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.type",
        name: "Expense type field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.project",
        name: "Project field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.purchase-code",
        name: "Purchase code field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.currency",
        name: "Currency field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.description",
        name: "Description field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.amount",
        name: "Amount field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.quantity",
        name: "Quantity field in the receipt form",
    },
    {
        tag: "admin-expenses.receipt.base-vat",
        name: "Base VAT field in the receipt form",
    },
    // ---
    // profile page
    {
        tag: "profile.$",
        name: "General manual for profile",
    },
    // general
    {
        tag: "profile.outlook.not-connected",
        name: "Outlook account is not connected",
    },
    {
        tag: "profile.outlook.calendar",
        name: "Calendar option in the Outlook account",
    },
    {
        tag: "profile.recurring-events.header",
        name: "Recurring events",
    },
    {
        tag: "profile.custom-activities.header",
        name: "Custom Activities",
    },
    {
        tag: "profile.custom-activities.use-start",
        name: "Use start & end time for custom activities",
    },
    {
        tag: "profile.tracks.import-template",
        name: "Import template button on profile page",
    },
    {
        tag: "profile.tracks.add-activity",
        name: "Add new activity button on profile page",
    },
    {
        tag: "profile.tracks.filter",
        name: "Filter tracks by active/archived on profile page",
    },
    {
        tag: "profile.tracks.archive",
        name: "Archive track button on profile page",
    },
    {
        tag: "profile.tracks.remove",
        name: "Remove track button on profile page",
    },
    {
        tag: "profile.tracks.template",
        name: "Template button for track on profile page",
    },
    {
        tag: "profile.tracks.fill-out",
        name: "Fill out button for track on profile page",
    },
] as const satisfies HelpTagDefinition[];

//
// every tag has a fallback tag, which is used when the tag is not found
// it should be the same tag with a question mark at the end
//
export const TAGS = BASE_TAGS.flatMap((tag) => [
    tag,
    {
        tag: `${tag.tag}?` as const,
        name: `Fallback for "${tag.name}"`,
        selectors: [],
    },
]);

export type HelpTag = (typeof TAGS)[number]["tag"];

type Selectors<T extends (typeof TAGS)[number]> = T extends {
    selectors: infer S;
}
    ? S
    : never;

type HelpTagToSelectors<
    Tag extends string,
    T extends (typeof TAGS)[number] = (typeof TAGS)[number],
> = T extends { tag: Tag } ? "$" | Selectors<T>[number]["selector"] : never;

export type HelpSelector<Tag extends HelpTag> = HelpTagToSelectors<Tag>;
